import * as actionTypes from '../actions/actionTypes';
import {updateState} from "../../shared/util";

const initialState = {
    products: [],
    indexedProducts: null,
    indexedProduct: null,
    loading: false,
    error: null
};

const getProductsRequest = (state, action) => {
    return updateState(state, {
        loading: true
    });
};

const getProductsSuccess = (state, action) => {
    const productsObject = {};
    const productObject = {};
    action.products.forEach(product => productsObject[product.id] = product);
    action.products.forEach(group => group.products.forEach(product => {
        productObject[product.id] = product
    }));

    return updateState(state, {
        loading: false,
        products: action.products,
        indexedProducts: productsObject,
        indexedProduct: productObject
    });
};

const getProductsError = (state, action) => {
    return updateState(state, {
        error: action.error
    });
};

const clearProductsError = (state, action) => {
    return updateState(state, {
        error: null
    });
};

export function productsReducer(state=initialState, action) {
    switch (action.type) {
        case actionTypes.GET_PRODUCTS_REQUEST :
            return getProductsRequest(state, action);

        case actionTypes.GET_PRODUCTS_SUCCESS :
            return getProductsSuccess(state, action);

        case actionTypes.GET_PRODUCTS_ERROR :
            return getProductsError(state, action);

        case actionTypes.CLEAR_ALL_ERRORS :
            return clearProductsError(state, action);

        default:
            return state;
    }
}
